export const NO_INDICATION = {
  id: 'no_indication',
  label: 'Assenza di indicazioni evidenziabili',
};

export const POSITIVE_GENETIC_HISTORY = {
  id: 'positive_genetic_history',
  label: 'Anamnesi genetica positiva',
};

export const HIGH_RISK_SCREENING_TEST = {
  id: 'high_risk_screening_test',
  label: 'Test di screening ad alto rischio',
};

export const MATERNAL_COUPLE_REQUEST = {
  id: 'maternal_couple_request',
  label: 'Volontà materna/della coppia',
};

export const FETAL_PATHOLOGY = {
  id: 'fetal_pathology',
  label: 'Patologia fetale',
};

export const UNKNOWN = {
  id: 'unknown',
  label: 'Non noto',
};
